import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ApiUrl/axiosConfig';
import reportWebVitals from './reportWebVitals';
import Router from './Router';
import Context, { Datacontext } from './Context';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Context>
      <>
        <Router />
        <ToastContainer />
      </>
    </Context>
  // </React.StrictMode>
);

reportWebVitals();
